<div class="col-md-12" *ngIf="userRequest">
    <h4>Details</h4>
    <ul>
        <li class="row mb-2">
            <div class="col-md-12 col-lg-4">
                <strong>Name: </strong>
            </div>
            <div class="col-md-12 col-lg-8">
                {{ userRequest.LastName }}, {{ userRequest.FirstName }}
            </div>
        </li>
        <li *ngIf="userRequest.UserID !== userRequest.ManagingUserID" class="row mb-2 managin-users-section">
            <div class="col-md-12 col-lg-4">
                <strong>Managing User: </strong>
            </div>
            <div class="col-md-12 col-lg-8">
                {{ userRequest.ManagingUserLastName }}, {{ userRequest.ManagingUserFirstName }}
            </div>
        </li>
        <li class="row mb-2">
            <div class="col-md-12 col-lg-4">
                <strong>Description: </strong>
            </div>
            <div class="col-md-12 col-lg-8">
                {{userRequest.Description}}
            </div>
        </li>
        <li class="row mb-2">
            <div class="col-md-12 col-lg-4">
                <strong>Status: </strong>
            </div>
            <div class="col-md-12 col-lg-8">
                {{ requestHelpersService.userStatusAndFollowUpStatusToString(userRequest.UserStatus, userRequest.FollowupStatusID) }}
            </div>
        </li>
        <li *ngIf="request.RosterPreference?.HasSeatLimit" class="row mb-2">
            <div class="col-md-12 col-lg-4">
                <strong>Seat Status: </strong>
            </div>
            <div class="col-md-12 col-lg-8">
                {{userRequest.IsSeatReserved ? 'Reserved' : 'Not Reserved'}}
            </div>
        </li>
        <li class="row mb-2 approvers-section" *ngIf="requestHelpersService.isPendingApproval(userRequest.UserStatus)">
            <div class="col-md-12 col-lg-4">
                <strong>Approver: </strong>
            </div>
            <div class="col-md-12 col-lg-8">
                {{ userRequest.PendingStatus }}
            </div>
        </li>
        <li *ngIf="request.FollowupRequired" class="row mb-2">
            <div class="col-md-12 col-lg-4">
                <strong>Follow-Up Due Date: </strong>
            </div>
            <div class="col-md-12 col-lg-8">
                <span>{{ userRequest.FollowupDueDate | dateExtended: 'MM/dd/yyyy' }}</span>
            </div>
        </li>
    </ul>
</div>
<br />
<div class="col-md-12" *ngIf="verificationHistory && verificationHistory.length > 0">
    <h4>History</h4>
    <ul class="history-item">
        <li *ngFor="let _historyItem of verificationHistory">
            <user-request-history-item
                [historyItem]="_historyItem"
                (onMessagesClicked)="onMessagesClicked()"
            ></user-request-history-item>
        </li>
    </ul>
</div>